<template>
    <div class="b">

        <div class="header">
            <div class="header-name">乌鸦背调</div>

            <div class="header-index">首页</div>
            <div class="header-index">产品</div>

            <div class="header-login" @click="login(3)">登录</div>
        </div>

        <div>
            <img class="bg-img" :src="bgImg" />
            <div class="middle">
                <div class="middle-one">乌鸦背调</div>
                <div class="middle-two">轻松下手</div>

                <div class="middle-three">
                    <div>快速背调|数据精准|真实履历</div>
                    <div>有效降低雇佣风险，</div>
                    <div>让你知人知面又知心。</div>
                </div>

                <div class="middle-four" @click="login">立即登录</div>
            </div>


            <div class="container">
                <div class="water">
                </div>
                
            </div>
        </div>

        <div class="bottom">

            <div class="bottom-two">
                <div>

                    <div>
                        <div>帮助与支持</div>
                        <div>
                            <ul>
                                <li>服务协议</li>
                                <li>隐私权政策</li>
                                <li>联系我们</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div>
                    <p style="font-size: 12px;"><a href="https://beian.miit.gov.cn">粤ICP备2022114400号-8</a></p>
                </div>
            </div>
        </div>

        <div class="suspend">
            <div style="margin-top:50px;">
                <el-image style="width:100px;height:100px;" src="../../wybd-logo.png"></el-image>
            </div>

            <div>
                <el-image style="width:100px;height:100px;" src="../../promote.jpg"></el-image>
            </div>
            <div>微信扫码</div>
            <div>立即咨询</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            bgImg: require('../assets/bg.png')
        }
    },
    methods: {
        login(val) {
            // console.log('val')
            // console.log(val)

            this.setLoginType(val)

            this.$router.push({
                path: "/Login"
            })
        }
    }
}
</script>

<style>
body {
    padding: 0;
    margin: 0;
}

.b {
    background: linear-gradient(to bottom, coral, white);
    color: black;
    height: 1300px;
    font-size: 16px;
}

.bg-img {
    position: absolute;
    top: -130px;
    right: 0px;
}

.header {
    display: flex;
    height: 34px;
    line-height: 34px;
    padding: 13px 10% 13px 15%;
}

.header-name {
    width: 70%;
    text-align: left;
    font-size: 20px;
}

.header-index {
    width: 100px;
}

.header-login {
    width: 120px;
    height: 34px;
    background-color: white;
    /* color: green; */
    border-radius: 6px;
    z-index: 1;
    margin: 0 10px;
}

.middle {
    font-size: 92px;
    font-weight: bold;
}

.middle>div {
    position: absolute;
    left: 15%;
}

.middle-one {
    height: 130px;
    top: 180px;
}

.middle-two {
    height: 130px;
    top: 310px;
}

.middle-three {
    font-size: 20px;
    top: 480px;
    text-align: left;
}

.middle-four {
    width: 200px;
    height: 60px;
    line-height: 60px;
    font-size: 22px;
    top: 630px;
    background-color: white;
    /* color: green; */
    border-radius: 6px;
}

#middle-five {
    font-size: 42px;
    color: black;
    top: 900px;
    left: 10%;
    right: 10%;
}

.middle-six {
    top: 1000px;
    display: flex;
    color: black;
    background-color: white;
    border-radius: 15px;
    width: 70%;
    height: 130px;
}

.middle-six>div {
    width: 25%;
    height: 100%;
    line-height: 130px;
    font-size: 16px;
}

.bottom {
    position: absolute;
    top: 1300px;
    width: 100%;
}

.bottom-one {
    background-color: green;
    width: 100%;
    height: 250px;
    padding: 100px 0;
}

.bottom-one>div:nth-child(1) {
    font-size: 42px;
    font-weight: bold;
    margin-bottom: 20px;
}

.bottom-one>div:nth-child(2) {
    font-size: 30px;
    margin-bottom: 50px;
}

.bottom-one>div>a {
    display: inline-block;
    width: 200px;
    height: 60px;
    line-height: 60px;
    border-radius: 6px;
    font-size: 22px;
    background-color: white;
    color: green;
}

.bottom-two {
    background-color: white;
    color: black;
    height: 340px;
}

.bottom-two>div:nth-child(1) {
    display: flex;
}

.bottom-two>div:nth-child(1)>div {
    width: 33%;
    padding-top: 50px;
    font-size: 20px;
    text-align: left;
}

.bottom-two>div:nth-child(1)>div:nth-child(1) {
    text-align: center;
}

.bottom-two ul {
    list-style-type: none;
    font-size: 14px;
}

.bottom-two ul li {
    float: left;
    width: 33%;
    margin-bottom: 10px;
}

.bottom-two>div:nth-child(2) {
    margin-top: 200px;
}

.suspend {
    position: fixed;
    right: 0px;
    bottom: 50px;
    width: 120px;
    height: 350px;
    background-color: green;
    color: white;
    border-radius: 120px;
}


.container {
  width: 100%;
  height: 300px;
  /* background: #1e90ff; */
  /* border-radius: 0 0 40% 40%; */
  position: relative;
  top:640px;
  overflow: hidden;
}

.water {
  position: absolute;
  bottom: -80px;
  left: -290px;
  width: 300%;
  height: 90%;
  background: #6ee0a2;
  border-radius: 50%;
  transform-origin: center;
  animation: wave 5s ease-in-out infinite;
}

@keyframes wave {

  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-55%);
  }
  100% {
    transform: translateX(0);
  }
  
}

</style>